module.exports = __webpack_public_path__ + "img/8_of_Clubs.svg.08375f2e.png";